"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
//******************************************************************************
// Copyright 2018-2020, ShareSquared Inc., All Rights Reserved.
//
// Author:  Ted Iverson
// Created: 06/22/2020
//
// The contents of this file are proprietary and considered trade secret.
// Any disclosure outside of its intended use is expressly prohibited.
//******************************************************************************
var React = require("react");
require("./App.css");
var SearchForm_1 = require("./SearchForm");
var TemplateSelector_1 = require("./TemplateSelector");
var SearchResults_1 = require("./SearchResults");
var ErrorSection_1 = require("./ErrorSection");
var RequestForm_1 = require("./RequestForm");
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props, state) {
        var _this = _super.call(this, props, state) || this;
        _this.state = {
            GlobalSettings: null,
            Template: null,
            Query: "",
            ErrorMessage: "",
            RequestFormOpen: false
        };
        return _this;
    }
    App.prototype.componentDidMount = function () {
        var _this = this;
        // After the component is loaded, request the global settings
        fetch((window.location.pathname === "/" ? "" : window.location.pathname) + "/api/settings?url=" + this.getLicenseUrl())
            .then(function (data) { return data.json(); }, function (e) {
            console.log(e);
            _this.setState({ Template: "", Query: "", ErrorMessage: "A general error occurred. Contact the site administrator." });
        })
            .then(function (settings) {
            _this.setState({ GlobalSettings: settings, ErrorMessage: (settings.isLicensed ? "" : "A license error occurred. Contact the site administrator.") });
            if (settings.pageTitle !== undefined && settings.pageTitle !== null && settings.pageTitle.length !== 0) {
                window.document.title = settings.pageTitle;
            }
        })
            .catch(function (e) {
            console.log(e);
            _this.setState({ Template: "", Query: "", ErrorMessage: "A general error occurred. Contact the site administrator." });
        });
    };
    App.prototype.render = function () {
        var _this = this;
        var element;
        if (this.state.GlobalSettings !== null) {
            if (this.state.GlobalSettings.isLicensed) {
                element =
                    React.createElement("div", { className: "App" },
                        React.createElement(TemplateSelector_1.default, { InitialTemplateName: this.props.InitialTemplateName, OnTemplateChanged: function (template) {
                                var _a;
                                _this.setState({ Template: template, Query: "", ErrorMessage: "", RequestFormOpen: false });
                                (_a = _this._SearchResults) === null || _a === void 0 ? void 0 : _a.clearResults();
                            }, OnError: function (errorMessage) {
                                _this.setState({ ErrorMessage: errorMessage });
                            } }),
                        React.createElement(SearchForm_1.default, { Template: this.state.Template, OnClear: function () {
                                var _a;
                                _this.setState({ Query: "", ErrorMessage: "", RequestFormOpen: false });
                                (_a = _this._SearchResults) === null || _a === void 0 ? void 0 : _a.clearResults();
                            }, OnSearch: function (query) {
                                var _a, _b;
                                _this.setState({ Query: query, ErrorMessage: "", RequestFormOpen: false });
                                (_a = _this._SearchResults) === null || _a === void 0 ? void 0 : _a.clearResults();
                                (_b = _this._SearchResults) === null || _b === void 0 ? void 0 : _b.search(query);
                            }, OnError: function (errorMessage) {
                                _this.setState({ ErrorMessage: errorMessage });
                            } }),
                        React.createElement(SearchResults_1.default, { Ref: function (c) { return _this._SearchResults = c; }, Query: this.state.Query, Template: this.state.Template, GlobalSettings: this.state.GlobalSettings, OnError: function (errorMessage) {
                                _this.setState({ ErrorMessage: errorMessage });
                            }, OnLinkError: function (errorMessage) {
                                alert(errorMessage);
                            }, OnManualRequest: function () {
                                _this.setState({ RequestFormOpen: true });
                            } }),
                        React.createElement(RequestForm_1.default, { IsVisible: this.state.RequestFormOpen, Query: this.state.Query, Template: this.state.Template, GlobalSettings: this.state.GlobalSettings, OnClear: function () {
                                _this.setState({ RequestFormOpen: false });
                            }, OnSearch: function (query) {
                            }, OnError: function (errorMessage) {
                                _this.setState({ ErrorMessage: errorMessage });
                            } }),
                        React.createElement(ErrorSection_1.default, { ErrorMessage: this.state.ErrorMessage }),
                        React.createElement("div", { className: "version" }, "Version 1.1.8"));
            }
            else {
                console.log("Product is not licensed");
                element =
                    React.createElement("div", { className: "App" },
                        React.createElement(ErrorSection_1.default, { ErrorMessage: this.state.ErrorMessage }));
            }
        }
        else {
            element = React.createElement("span", null);
        }
        return element;
    };
    App.prototype.getLicenseUrl = function () {
        var licensedUrl = "";
        var url = (window.parent !== window) ? document.referrer : window.location.href;
        console.log("originalUrl=" + url);
        //const rx = new RegExp("^https?://([^/]+)(/.*)?$");
        var rx = new RegExp("^https?://([^/]+)(/[^#\?]*)?");
        var m = rx.exec(url);
        if (m != null) {
            if (m.length < 3) {
                m.push("/");
            } // if root
            licensedUrl = m[2].toLowerCase();
        }
        console.log("licenseUrl=" + licensedUrl);
        return licensedUrl;
    };
    return App;
}(React.Component));
exports.default = App;
//# sourceMappingURL=App.js.map